import api from './api';

const productOptionsService = {
  // List all available options for presentation
  getAllAvailable: async () => {
    const response = await api.get('/product-options/disponiveis');
    return response.data;
  },

  // Get options for a specific product
  getByProduct: async (produtoId) => {
    const response = await api.get(`/product-options/produto/${produtoId}`);
    return response.data;
  },

  // Create new option
  create: async (data) => {
    const response = await api.post('/product-options', data);
    return response.data;
  },

  // Update option
  update: async (id, data) => {
    const response = await api.put(`/product-options/${id}`, data);
    return response.data;
  },

  // Delete option (soft delete)
  delete: async (id) => {
    const response = await api.delete(`/product-options/${id}`);
    return response.data;
  },

  // Save client choice during presentation
  saveChoice: async (surveyId, data) => {
    const response = await api.post(`/product-options/escolhas/${surveyId}`, data);
    return response.data;
  },

  // Get choices for a survey
  getChoices: async (surveyId) => {
    const response = await api.get(`/product-options/escolhas/${surveyId}`);
    return response.data;
  },

  // Delete choice
  deleteChoice: async (id) => {
    const response = await api.delete(`/product-options/escolhas/${id}`);
    return response.data;
  },
};

export default productOptionsService;
